(function () {

  // ── Caches de fetch ─────────────────────────────────────────────────────────

  const cache = {};

  function fetchProductData(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(Shopify.routes.root + 'products/' + handle + '?view=dt-json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  const cardCache = {};

  function fetchCardHtml(handle) {
    if (!cardCache[handle]) {
      cardCache[handle] = fetch(Shopify.routes.root + 'products/' + handle + '?view=dt-card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    }
    return cardCache[handle];
  }

  // ── Variante seleccionada ───────────────────────────────────────────────────

  function initVariantSelector(card) {
    var items = card.querySelectorAll('.dt-product-card__variants-overlay .dt-selector__item');
    if (!items.length) return;

    var firstItem = card.querySelector('.dt-product-card__variants-overlay .dt-selector__item:not(.is-disabled)');
    if (firstItem) selectVariant(card, firstItem.querySelector('.dt-selector__swatch'));

    items.forEach(function (item) {
      var btn = item.querySelector('.dt-selector__swatch');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        selectVariant(card, btn);
      });
    });
  }

  function selectVariant(card, btn) {
    var swatchRoot = card.querySelector('.dt-product-card__variants-overlay')
      || document.querySelector('.dt-product-card__variants-overlay.dt-sheet-active');
    if (swatchRoot) {
      swatchRoot.querySelectorAll('.dt-selector__swatch').forEach(function (s) {
        s.closest('.dt-selector__item').classList.remove('dt-selector__item--current');
      });
    }
    btn.closest('.dt-selector__item').classList.add('dt-selector__item--current');
    var idInput = card.querySelector('.dt-card-atc-id');
    if (idInput) idInput.value = btn.dataset.variantId;
  }

  // ── Selector de material ────────────────────────────────────────────────────

  function processCard(ul) {
    if (ul.dataset.dtSelectorMaterialDone) return;
    ul.dataset.dtSelectorMaterialDone = '1';

    var currentMaterial = {
      label: ul.dataset.materialLabel,
      image: ul.dataset.materialImage,
      order: parseInt(ul.dataset.materialOrder, 10) || 999
    };
    var currentCirconita = ul.dataset.circonita;
    var currentGema      = ul.dataset.gema;
    var currentHandle    = ul.dataset.handle;
    var relHandles = ul.dataset.rels ? ul.dataset.rels.split(',').filter(Boolean) : [];

    if (!relHandles.length) return;

    Promise.all(relHandles.map(fetchProductData)).then(function (results) {
      var seen = {};
      seen[currentMaterial.label] = true;
      var entries = [{ material: currentMaterial, handle: currentHandle, isCurrent: true, available: true }];

      results.forEach(function (data) {
        if (!data || !data.material || !data.material.label) return;
        if ((data.circonita || '') !== currentCirconita || (data.gema || '') !== currentGema) return;
        if (seen[data.material.label]) return;
        seen[data.material.label] = true;
        entries.push({ material: data.material, handle: data.handle, isCurrent: false, available: data.available !== false });
      });

      if (entries.length <= 1) return;

      // Orden visual: campo Order del metaobject de material (ya no hay lista ES/EN/FR hardcodeada, TASK-0039)
      entries.sort(function (a, b) {
        return (a.material.order || 999) - (b.material.order || 999);
      });

      ul.innerHTML = '';
      entries.forEach(function (entry) {
        var li = document.createElement('li');
        li.className = 'dt-selector__item' + (entry.isCurrent ? ' dt-selector__item--current' : '') + (!entry.available ? ' is-disabled' : '');
        var a = document.createElement('a');
        a.href = Shopify.routes.root + 'products/' + entry.handle;
        a.className = 'dt-selector__swatch';
        a.setAttribute('aria-label', entry.material.label);
        a.setAttribute('data-value', entry.material.label);
        if (entry.material.image) {
          a.style.background = "center / contain no-repeat url('" + entry.material.image + "')";
        }
        a.dataset.handle = entry.handle;
        if (entry.isCurrent) {
          a.setAttribute('aria-current', 'page');
        } else {
          a.addEventListener('click', function (e) {
            e.preventDefault();
            swapCard(ul, entry.handle);
          });
        }
        li.appendChild(a);
        ul.appendChild(li);
      });
    });
  }

  // ── Drag-to-scroll en slider de imágenes (desktop) ─────────────────────────

  function initSliderDrag(card) {
    if (window.matchMedia('(min-width: 1000px)').matches) return;
    var slider = card.querySelector('.dt-card-slider');
    if (!slider || slider.dataset.dtSliderDrag) return;
    slider.dataset.dtSliderDrag = '1';

    var isDragging = false;
    var startX = 0;
    var scrollLeft = 0;
    var hasDragged = false;

    slider.addEventListener('mousedown', function (e) {
      isDragging = true;
      hasDragged = false;
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
      slider.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) hasDragged = true;
      slider.scrollLeft = scrollLeft - dx;
    });

    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      slider.style.cursor = 'grab';
      slider.style.userSelect = '';
    });

    slider.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        hasDragged = false;
      }
    });

    slider.style.cursor = 'grab';
  }

  // ── Flujo ATC en móvil (dos toques) ────────────────────────────────────────

  function initMobileAtcFlow(card) {
    var overlay = card.querySelector('.dt-product-card__variants-overlay');
    if (!overlay) return;

    var openBtn   = card.querySelector('.product-card__quick-add-button');
    if (!openBtn || openBtn.dataset.dtMobileAtcDone) return;
    openBtn.dataset.dtMobileAtcDone = '1';

    var backdrop      = overlay.querySelector('.dt-sheet-backdrop');
    var panel         = overlay.querySelector('.dt-sheet-panel');
    var atcBtn        = panel ? panel.querySelector('.dt-sheet-atc-btn') : null;
    var submitBtn     = card.querySelector('.dt-card-atc-submit');
    var overlayParent = overlay.parentNode;

    function closeSheet(e) {
      if (e) e.stopPropagation();
      overlay.classList.remove('dt-sheet-active');
      if (overlay.parentNode === document.body) overlayParent.appendChild(overlay);
      card.classList.remove('dt-mobile-overlay-open');
      document.body.classList.remove('dt-sheet-open');
      var lookTrigger = document.querySelector('[aria-controls="look-drawer"]');
      if (lookTrigger && lookTrigger.getAttribute('aria-expanded') === 'true') {
        lookTrigger.click();
      }
    }

    openBtn.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 999px)').matches) {
        document.body.appendChild(overlay);
        overlay.classList.add('dt-sheet-active');
        card.classList.add('dt-mobile-overlay-open');
        document.body.classList.add('dt-sheet-open');
      } else if (submitBtn) {
        submitBtn.click();
      }
    });

    if (backdrop) backdrop.addEventListener('click', closeSheet);

    if (panel) {
      var touchStartY = 0;
      panel.addEventListener('touchstart', function (e) {
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      panel.addEventListener('touchend', function (e) {
        if (e.changedTouches[0].clientY - touchStartY > 60) closeSheet();
      }, { passive: true });
    }

    if (atcBtn && submitBtn) {
      atcBtn.addEventListener('click', function () {
        submitBtn.click();
        setTimeout(closeSheet, 300);
      });
    }
  }

  // ── Swap de card al cambiar material ───────────────────────────────────────

  function swapCard(ul, handle) {
    var productCard = ul.closest('product-card');
    if (!productCard) return;

    fetchCardHtml(handle).then(function (html) {
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      var newCard = tmp.querySelector('product-card');
      if (!newCard) return;

      productCard.replaceWith(newCard);
      processAll(newCard);
      initVariantSelector(newCard);
      initMobileAtcFlow(newCard);
      initSliderDrag(newCard);
    });
  }

  function processAll(root) {
    root.querySelectorAll('[data-dt-selector-material]').forEach(processCard);
  }

  // ── DT Slideshow: carrusel propio (hereda de SlideshowCarousel) ─────────────
  // TASK-0019: dt-slideshow-carousel hereda todo el comportamiento de
  // SlideshowCarousel (autoplay, swipe, vídeo, puntos de navegación) y solo
  // sobreescribe createOnChangeAnimationControls para poder ofrecer, además del
  // fundido original, una transición de deslizamiento horizontal cuando el
  // atributo transition-style="slide" está presente (ver dt-slideshow.liquid).
  //
  // El ciclo base (EffectCarousel.select(), en theme.js) es secuencial: primero
  // termina de salir la slide actual, luego se intercambian las clases
  // is-selected, luego entra la nueva. leaveControls/enterControls deben
  // devolver un objeto con .finished (promise) y .finish() (usado en modo
  // instantáneo), igual que el que ya usa SlideshowCarousel — por eso se
  // envuelve cada Animation nativa (Element.animate) en ese mismo contrato.

  function animateSlideTransform(element, fromX, toX, duration, easing) {
    var animation = element.animate(
      [{ transform: 'translateX(' + fromX + ')' }, { transform: 'translateX(' + toX + ')' }],
      { duration: duration, easing: easing, fill: 'both' }
    );
    return {
      finished: animation.finished.then(function () {
        animation.commitStyles();
        animation.cancel();
      }),
      finish: function () { animation.finish(); }
    };
  }

  (function initDtSlideshowCarousel() {
    if (window.customElements.get('dt-slideshow-carousel')) return;

    import('theme').then(function (themeModule) {
      var SlideshowCarousel = themeModule.SlideshowCarousel;

      class DtSlideshowCarousel extends SlideshowCarousel {
        createOnChangeAnimationControls(fromSlide, toSlide, options) {
          var direction = options && options.direction;

          if (this.getAttribute('transition-style') !== 'slide') {
            return super.createOnChangeAnimationControls(fromSlide, toSlide, options);
          }

          var duration = 350;
          var easing = 'cubic-bezier(0.65, 0, 0.35, 1)';
          var leaveTo = direction === 'previous' ? '100%' : '-100%';
          var enterFrom = direction === 'previous' ? '-100%' : '100%';

          return {
            leaveControls: function () {
              return animateSlideTransform(fromSlide, '0%', leaveTo, duration, easing);
            },
            enterControls: function () {
              return animateSlideTransform(toSlide, enterFrom, '0%', duration, easing);
            }
          };
        }
      }

      window.customElements.define('dt-slideshow-carousel', DtSlideshowCarousel);
    });
  })();

  // ── Wishlist (TASK-0077) ────────────────────────────────────────────────────
  // Botón de favorito <dt-wishlist-button> (snippets/dt-wishlist-button.liquid). Dos almacenes tras la misma
  // interfaz: sin sesión, localStorage (solo en este navegador); con sesión, API de Fidelcity v2 identificando al
  // cliente por la cabecera X-Cliente-Email (data-customer-email). Al iniciar sesión, los favoritos locales se
  // fusionan con la API (TASK-0102).
  // Todo el acceso a la API vive en las funciones wishlistApi*; cambiar URL o método no toca el resto.

  var WISHLIST_API_BASE = 'https://apifidelcity.developdt.com/api';
  // Clave pública de la API (preprod): la API pide usarla solo desde servidor, pero el theme llama desde el navegador
  // por decisión explícita (RISK-024).
  var WISHLIST_API_KEY = 'h7DWnGkdBG5NS2n6LbwDh5OSGCwt8kZWCuf3UvBma97V1Rsa9qnkFBmqf9rC';
  var WISHLIST_STORAGE_KEY = 'dt_wishlist';

  // Almacén local: lista de { id, handle }. Se carga una vez; si localStorage está bloqueado, el estado vive en memoria.
  var wishlistLocalItems = null;

  function wishlistLocalLoad() {
    if (wishlistLocalItems) return wishlistLocalItems;
    wishlistLocalItems = [];
    try {
      var parsed = JSON.parse(window.localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]');
      if (Array.isArray(parsed)) {
        wishlistLocalItems = parsed.filter(function (item) { return item && item.id; })
          .map(function (item) { return { id: String(item.id), handle: String(item.handle || '') }; });
      }
    } catch (e) { /* almacenamiento bloqueado o JSON corrupto: se parte de una lista vacía */ }
    return wishlistLocalItems;
  }

  function wishlistLocalSave() {
    try {
      window.localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(wishlistLocalItems));
    } catch (e) { /* sin persistencia: el cambio solo dura lo que dure la página */ }
  }

  function wishlistLocalAdd(item) {
    var items = wishlistLocalLoad();
    if (!items.some(function (i) { return i.id === item.id; })) items.push({ id: item.id, handle: item.handle });
    wishlistLocalSave();
  }

  function wishlistLocalRemove(id) {
    wishlistLocalItems = wishlistLocalLoad().filter(function (i) { return i.id !== id; });
    wishlistLocalSave();
  }

  // Capa de llamadas a la API de Fidelcity (D8).
  function wishlistApi(method, path, email, body) {
    var options = {
      method: method,
      headers: {
        Accept: 'application/json',
        'X-Api-Key': WISHLIST_API_KEY,
        'X-Cliente-Email': email,
        'X-Shopify-Shop-Domain': window.Shopify && window.Shopify.shop
      }
    };
    if (body) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(WISHLIST_API_BASE + path, options).then(function (r) {
      if (!r.ok) {
        var error = new Error('wishlist api ' + r.status);
        error.status = r.status;
        throw error;
      }
      return r;
    });
  }

  function wishlistApiList(email) {
    return wishlistApi('GET', '/favoritos', email).then(function (r) { return r.json(); }).then(function (data) {
      return ((data && data.favoritos) || []).map(function (f) {
        return { id: String(f.Id_Producto_Shopify), handle: String(f.Handle_Shopify || '') };
      });
    });
  }

  function wishlistApiAdd(email, id, handle) {
    // El handle lo guarda el backend y lo devuelve en el listado como Handle_Shopify (Url_Amigable no es fiable)
    return wishlistApi('POST', '/favoritos', email, { id_producto: Number(id), handle: handle });
  }

  function wishlistApiRemove(email, id) {
    return wishlistApi('DELETE', '/favoritos/' + encodeURIComponent(id), email).catch(function (error) {
      if (error.status !== 404) throw error; // 404: ya no estaba en favoritos, el resultado es el mismo
    });
  }

  // Estado de la página: ids favoritos del almacén activo. Se carga una sola vez (con sesión: fusión + listado).
  var wishlistIds = new Set();
  var wishlistPending = {};
  var wishlistReadyPromise = null;
  // Entradas { id, handle } del listado remoto y si ese listado falló (la página "Mis favoritos" los distingue de una lista vacía)
  var wishlistEntries = [];
  var wishlistListFailed = false;

  function wishlistReady(email) {
    if (wishlistReadyPromise) return wishlistReadyPromise;

    if (!email) {
      wishlistLocalLoad().forEach(function (item) { wishlistIds.add(item.id); });
      wishlistReadyPromise = Promise.resolve();
      return wishlistReadyPromise;
    }

    // Fusión de los favoritos que el invitado marcó antes de iniciar sesión. Los que fallen se conservan y se
    // reintentan en la siguiente página.
    var localItems = wishlistLocalLoad().slice();
    var merge = Promise.all(localItems.map(function (item) {
      return wishlistApiAdd(email, item.id, item.handle).then(function () { wishlistLocalRemove(item.id); }, function () {});
    }));

    wishlistReadyPromise = merge.then(function () {
      return wishlistApiList(email);
    }).then(function (entries) {
      wishlistEntries = entries;
      entries.forEach(function (entry) { wishlistIds.add(entry.id); });
    }).catch(function () {
      // Sin lista no se rompe nada: corazones vacíos
      wishlistListFailed = true;
    });
    return wishlistReadyPromise;
  }

  function wishlistSync(productId) {
    document.querySelectorAll('dt-wishlist-button[data-product-id="' + productId + '"]').forEach(function (button) {
      button.render();
    });
  }

  var wishlistToastTimer = null;

  function wishlistShowError(message) {
    var toast = document.querySelector('.dt-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'dt-wishlist-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(wishlistToastTimer);
    wishlistToastTimer = setTimeout(function () { toast.hidden = true; }, 3000);
  }

  class DtWishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      if (!this.dtWishlistBound) {
        this.dtWishlistBound = true;
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      wishlistReady(this.dataset.customerEmail || '').then(this.render.bind(this));
    }

    render() {
      if (!this.button) return;
      var id = this.dataset.productId;
      var active = wishlistIds.has(id);
      var label = active ? this.dataset.labelRemove : this.dataset.labelAdd;

      this.classList.toggle('is-active', active);
      this.classList.toggle('is-loading', !!wishlistPending[id]);
      this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
      this.button.setAttribute('aria-label', label);

      var labelEl = this.querySelector('.dt-wishlist__label');
      if (labelEl) labelEl.textContent = label;
    }

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();

      var id = this.dataset.productId;
      var handle = this.dataset.productHandle;
      var email = this.dataset.customerEmail || '';
      var errorLabel = this.dataset.labelError;
      if (wishlistPending[id]) return;

      wishlistReady(email).then(function () {
        if (wishlistPending[id]) return;
        var wasActive = wishlistIds.has(id);

        // Cambio optimista: el icono responde al instante y se revierte si la petición falla
        if (wasActive) wishlistIds.delete(id); else wishlistIds.add(id);

        var request;
        if (email) {
          wishlistPending[id] = true;
          request = wasActive ? wishlistApiRemove(email, id) : wishlistApiAdd(email, id, handle);
        } else {
          if (wasActive) wishlistLocalRemove(id); else wishlistLocalAdd({ id: id, handle: handle });
          request = Promise.resolve();
        }
        wishlistSync(id);

        request.then(function () {
          document.dispatchEvent(new CustomEvent('wishlist:updated', {
            detail: { productId: id, handle: handle, active: !wasActive }
          }));
        }).catch(function () {
          if (wasActive) wishlistIds.add(id); else wishlistIds.delete(id);
          wishlistShowError(errorLabel);
        }).then(function () {
          delete wishlistPending[id];
          wishlistSync(id);
        });
      });
    }
  }

  if (!window.customElements.get('dt-wishlist-button')) {
    window.customElements.define('dt-wishlist-button', DtWishlistButton);
  }

  // ── Icono de favoritos del header (TASK-0096) ───────────────────────────────
  // <dt-wishlist-indicator> (sections/dt-header.liquid) alterna entre el icono normal y el icono con aviso según haya o no
  // favoritos. Pinta al instante el último estado conocido (invitado: el almacén local; con sesión: la clave
  // WISHLIST_HAS_ITEMS_KEY, para no esperar a la API) y lo corrige con el resultado real de wishlistReady.
  var WISHLIST_HAS_ITEMS_KEY = 'dt_wishlist_has_items';

  class DtWishlistIndicator extends HTMLElement {
    connectedCallback() {
      var email = this.dataset.customerEmail || '';
      this.setActive(this.knownState(email));

      if (!this.onUpdatedBound) this.onUpdatedBound = this.refresh.bind(this);
      document.addEventListener('wishlist:updated', this.onUpdatedBound);

      wishlistReady(email).then(function () {
        // Si el listado de la API falló no se sabe el estado real: se conserva el último conocido
        if (email && wishlistListFailed) return;
        this.refresh();
      }.bind(this));
    }

    disconnectedCallback() {
      if (this.onUpdatedBound) document.removeEventListener('wishlist:updated', this.onUpdatedBound);
    }

    knownState(email) {
      if (!email) return wishlistLocalLoad().length > 0;
      try {
        return window.localStorage.getItem(WISHLIST_HAS_ITEMS_KEY) === '1';
      } catch (e) { return false; }
    }

    refresh() {
      var active = wishlistIds.size > 0;
      try {
        window.localStorage.setItem(WISHLIST_HAS_ITEMS_KEY, active ? '1' : '0');
      } catch (e) { /* sin persistencia: solo se pierde el pintado inmediato de la próxima página */ }
      this.setActive(active);
    }

    setActive(active) {
      this.classList.toggle('has-items', active);
    }
  }

  if (!window.customElements.get('dt-wishlist-indicator')) {
    window.customElements.define('dt-wishlist-indicator', DtWishlistIndicator);
  }

  // ── Página "Mis favoritos" (TASK-0069) ──────────────────────────────────────
  // <dt-wishlist-page> (sections/dt-wishlist-page.liquid) pinta las cards de los favoritos del almacén activo.
  // Los estados (cargando, vacío, error, lista) se muestran con [data-dt-wishlist-state]; las cards se piden con
  // fetchCardHtml y, al insertarse por JS, se inicializan igual que las de Ajaxinate (PAT-004).

  class DtWishlistPage extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.dt-wishlist-page__list');
      if (!this.list) return;

      this.onUpdatedBound = this.onUpdated.bind(this);
      document.addEventListener('wishlist:updated', this.onUpdatedBound);
      this.load();
    }

    disconnectedCallback() {
      if (this.onUpdatedBound) document.removeEventListener('wishlist:updated', this.onUpdatedBound);
    }

    setState(state) {
      var isGuest = !this.dataset.customerEmail;
      this.querySelectorAll('[data-dt-wishlist-state]').forEach(function (element) {
        var states = element.getAttribute('data-dt-wishlist-state').split(' ');
        element.hidden = states.indexOf(state) === -1 || (element.hasAttribute('data-dt-wishlist-guest') && !isGuest);
      });
    }

    load() {
      var self = this;
      var email = this.dataset.customerEmail || '';
      this.setState('loading');

      wishlistReady(email).then(function () {
        if (email && wishlistListFailed) {
          self.setState('error');
          return;
        }

        var entries = (email ? wishlistEntries : wishlistLocalLoad()).filter(function (entry) { return entry.handle; });
        if (!entries.length) {
          self.setState('empty');
          return;
        }

        // Las peticiones van en paralelo, pero las cards se insertan en el orden de la lista. Las que no se pueden
        // obtener (producto borrado o no publicado) se omiten.
        return Promise.all(entries.map(function (entry) { return fetchCardHtml(entry.handle); })).then(function (htmls) {
          var cards = [];
          htmls.forEach(function (html) {
            if (!html) return;
            var tmp = document.createElement('div');
            tmp.innerHTML = html.trim();
            var card = tmp.querySelector('product-card');
            if (card) cards.push(card);
          });

          if (!cards.length) {
            self.setState('empty');
            return;
          }

          cards.forEach(function (card) { self.list.appendChild(card); });
          // La lista se muestra antes de inicializar para que los cálculos de tamaño (slider) vean las cards visibles
          self.setState('list');
          cards.forEach(function (card) {
            processAll(card);
            initVariantSelector(card);
            initMobileAtcFlow(card);
            initSliderDrag(card);
          });
        });
      }).catch(function () {
        self.setState('error');
      });
    }

    onUpdated(event) {
      if (this.list.hidden || !event.detail || event.detail.active) return;

      var button = this.list.querySelector('dt-wishlist-button[data-product-id="' + event.detail.productId + '"]');
      var card = button && button.closest('product-card');
      if (card) card.remove();
      if (!this.list.querySelector('product-card')) this.setState('empty');
    }
  }

  if (!window.customElements.get('dt-wishlist-page')) {
    window.customElements.define('dt-wishlist-page', DtWishlistPage);
  }

  // ── Inicialización ──────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {

    // Product cards
    processAll(document);
    document.querySelectorAll('product-card').forEach(function (card) {
      initVariantSelector(card);
      initMobileAtcFlow(card);
      initSliderDrag(card);
    });

    // Ajaxinate: re-inicializar cards nuevas al hacer scroll infinito
    var productList = document.querySelector('.product-list-ajaxinate');
    if (productList) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.classList && node.classList.contains('product-card')) {
              node.style.opacity = '1';
              node.style.transform = 'translateY(0)';
            }
            if (node.matches('[data-dt-selector-material]')) {
              processCard(node);
            } else {
              processAll(node);
            }
            if (node.matches('product-card')) {
              initVariantSelector(node);
              initMobileAtcFlow(node);
              initSliderDrag(node);
            } else if (node.querySelector) {
              node.querySelectorAll('product-card').forEach(function (card) {
                initVariantSelector(card);
                initMobileAtcFlow(card);
                initSliderDrag(card);
              });
            }
          });
        });
      }).observe(productList, { childList: true, subtree: true });
    }

    // Ficha de producto: un solo colapsable abierto a la vez (TASK-0080). Listener delegado en fase de captura,
    // para leer el estado previo antes de que AccordionDisclosure lo cambie; cierra los demás con su close() nativo
    // (mantiene animación y aria-expanded). Alcance: el mismo <product-rerender>.
    document.addEventListener('click', function (event) {
      var summary = event.target.closest && event.target.closest('accordion-disclosure > details > summary');
      if (!summary) return;
      var current = summary.closest('accordion-disclosure');
      var scope = current.closest('product-rerender');
      if (!scope || current.querySelector('details').getAttribute('aria-expanded') === 'true') return;
      scope.querySelectorAll('accordion-disclosure').forEach(function (other) {
        if (other !== current && other.querySelector('details').getAttribute('aria-expanded') === 'true') {
          other.close();
        }
      });
    }, true);

    // Ficha de producto: autoplay de los vídeos de la galería (TASK-0092). El autoplay nativo de Prestige solo salta en
    // carousel:settle, y en escritorio la galería es una rejilla (grid_2x), sin carrusel. Aquí cada <video-media> de
    // Shopify se reproduce al entrar en pantalla (muted) y se pausa al salir, con el play()/pause() nativo del elemento.
    // Solo actúa si <product-gallery> lleva autoplay-media (ajuste enable_media_autoplay); con ese ajuste el Liquid no
    // pinta los controles (dt-product-gallery.liquid). Con prefers-reduced-motion no se reproduce solo y se restituyen
    // los controles para poder iniciarlo y pausarlo.
    var galleryRerender = document.querySelector('product-rerender');
    var galleryReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (galleryRerender) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var videoMedia = entry.target;
          var video = videoMedia.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            video.muted = true;
            videoMedia.play();
          } else {
            videoMedia.pause();
          }
        });
      }, { threshold: 0.5 });

      var observeGalleryVideos = function () {
        document.querySelectorAll('product-gallery[autoplay-media] video-media[type="video"]').forEach(function (videoMedia) {
          var video = videoMedia.querySelector('video');
          if (!video || videoMedia.dtObserved) return;
          videoMedia.dtObserved = true;
          if (galleryReducedMotion) {
            video.controls = true;
            return;
          }
          videoObserver.observe(videoMedia);
        });
      };

      observeGalleryVideos();
      var galleryScope = galleryRerender.closest('.shopify-section') || galleryRerender.parentElement;
      new MutationObserver(observeGalleryVideos).observe(galleryScope, { childList: true, subtree: true });
    }

    // Cart Drawer: bolsa para regalo (TASK-0086). Casilla -> cart/update.js (añade/quita la variante) con la sección del
    // drawer empaquetada, y cart:change para que drawer, contador y punto del carrito se actualicen. Si tras refrescar el
    // drawer la bolsa es la única línea, se quita sola.
    function dtGiftBagUpdate(variantId, quantity) {
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var updates = {};
      updates[variantId] = quantity;
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sections.join(',') })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart/update failed');
        return response.json();
      }).then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'dt-gift-bag:change', cart: cart } }));
      }).finally(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      });
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('dt-gift-bag__input')) return;
      var variantId = input.closest('.dt-gift-bag').getAttribute('data-dt-gift-bag-variant');
      var wanted = input.checked;
      input.disabled = true;
      dtGiftBagUpdate(variantId, wanted ? 1 : 0).catch(function (error) {
        console.error('[TASK-0086] bolsa de regalo:', error);
        input.checked = !wanted;
      }).finally(function () {
        input.disabled = false;
      });
    });

    // Cart Drawer: casilla de la nota del pedido (TASK-0099). Solo informativa: marcada si hay nota. <cart-note> (theme.js)
    // guarda la nota en el change del campo y no re-renderiza el drawer, así que aquí se sincroniza la casilla.
    document.addEventListener('change', function (event) {
      var field = event.target;
      if (!field.matches || !field.matches('.cart-drawer__order-note textarea[name="note"]')) return;
      var check = field.closest('.dt-cart-drawer__note').querySelector('.dt-cart-drawer__note-check input');
      if (check) check.checked = field.value.trim() !== '';
    });

    document.addEventListener('cart-drawer:refreshed', function (event) {
      var drawer = event.target;
      var bag = drawer.querySelector('.dt-gift-bag');
      var input = bag && bag.querySelector('.dt-gift-bag__input');
      if (!input || !input.checked) return;
      if (drawer.querySelectorAll('.cart-drawer__items line-item').length === 1) {
        dtGiftBagUpdate(bag.getAttribute('data-dt-gift-bag-variant'), 0);
      }
    });

    // Ficha de producto: barra fija de compra (TASK-0100). La nativa (<product-sticky-bar>, theme.js) se oculta cuando el
    // footer entra en pantalla; en escritorio la queremos visible también ahí. <dt-product-sticky-pin>, hijo oculto de la
    // barra, marca la barra con dt-sticky-pinned cuando el formulario de compra ya salió por arriba (misma condición que
    // la nativa, sin mirar el footer); el CSS la mantiene visible solo en escritorio. Es aditivo: si falla, queda el
    // comportamiento nativo. Se reconecta solo en cada re-render de la barra (cambio de variante).
    class DtProductStickyPin extends HTMLElement {
      connectedCallback() {
        this.bar = this.closest('product-sticky-bar');
        var form = this.bar && document.forms[this.bar.getAttribute('form')];
        if (!form) return;

        this.observer = new IntersectionObserver(function (entries) {
          var entry = entries[entries.length - 1];
          this.bar.classList.toggle('dt-sticky-pinned', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        }.bind(this));
        this.observer.observe(form);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    if (!window.customElements.get('dt-product-sticky-pin')) {
      window.customElements.define('dt-product-sticky-pin', DtProductStickyPin);
    }

    // Ficha de producto: mensaje de envío (TASK-0083). El servidor pinta el mensaje estándar con los importes del país del
    // visitante (metafield de tienda "Envío por país"); aquí solo se conmuta a "Envío gratis conseguido" cuando el total del
    // carrito (con descuentos, /cart.js) alcanza el umbral. Se actualiza con cart:change.
    class DtShippingMessage extends HTMLElement {
      connectedCallback() {
        this.textElement = this.querySelector('[data-dt-shipping-text]');
        this.threshold = parseInt(this.dataset.threshold, 10);
        if (!this.textElement || !(this.threshold > 0)) return;

        this.onCartChange = function (event) {
          var cart = event.detail && event.detail.cart;
          if (cart && typeof cart.total_price === 'number') this.update(cart.total_price);
          else this.refresh();
        }.bind(this);
        document.addEventListener('cart:change', this.onCartChange);
        this.refresh();
      }

      disconnectedCallback() {
        if (this.onCartChange) document.removeEventListener('cart:change', this.onCartChange);
      }

      refresh() {
        var self = this;
        fetch(window.Shopify.routes.root + 'cart.js').then(function (response) {
          return response.json();
        }).then(function (cart) {
          self.update(cart.total_price);
        }).catch(function () {});
      }

      update(total) {
        var reached = total >= this.threshold;
        var text = reached && this.dataset.reached ? this.dataset.reached : this.dataset.standard;
        this.textElement.innerHTML = text;
        this.classList.toggle('is-reached', reached);
      }
    }

    if (!window.customElements.get('dt-shipping-message')) {
      window.customElements.define('dt-shipping-message', DtShippingMessage);
    }

    // Cart Drawer: barra de envío gratis (TASK-0088, snippets/dt-free-shipping-bar.liquid). El servidor la pinta con el
    // umbral del país del visitante (DEC-022); aquí se recalcula en cada cart:change con el mismo criterio que la barra
    // nativa: líneas con envío menos los descuentos de carrito.
    class DtFreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10);
        this.fill = this.querySelector('.dt-free-shipping__fill');
        this.textElement = this.querySelector('[data-dt-free-shipping-text]');
        if (!(this.threshold > 0) || !this.fill || !this.textElement) return;

        this.onCartChange = function (event) {
          var cart = event.detail && event.detail.cart;
          if (cart && cart.items) this.update(cart);
        }.bind(this);
        document.addEventListener('cart:change', this.onCartChange);
      }

      disconnectedCallback() {
        if (this.onCartChange) document.removeEventListener('cart:change', this.onCartChange);
      }

      update(cart) {
        var total = cart.items.filter(function (item) { return item.requires_shipping; }).reduce(function (sum, item) {
          return sum + item.final_line_price;
        }, 0);
        total -= (cart.cart_level_discount_applications || []).reduce(function (sum, discount) {
          return sum + discount.total_allocated_amount;
        }, 0);

        var reached = total >= this.threshold;
        var progress = reached ? 100 : Math.max(0, Math.min(100, (total / this.threshold) * 100));
        this.fill.style.width = progress + '%';
        this.classList.toggle('is-reached', reached);

        if (reached) {
          this.textElement.innerHTML = this.dataset.reached;
        } else {
          var formatter = new Intl.NumberFormat(window.Shopify.locale, { style: 'currency', currency: window.Shopify.currency.active });
          // Sin espacio entre el importe y el símbolo, como el resto de precios de la tienda ("4,00€")
          var remaining = formatter.format((this.threshold - total) / 100).replace(/\s+/g, '');
          this.textElement.innerHTML = this.dataset.unreached.replace('[restante]', remaining);
        }
      }
    }

    if (!window.customElements.get('dt-free-shipping-bar')) {
      window.customElements.define('dt-free-shipping-bar', DtFreeShippingBar);
    }

    // Ficha de producto: cuenta atrás de envío (TASK-0084). Se calcula en el navegador con la hora de Europa/Madrid
    // (el envío sale siempre de España): hoy se envía si es laborable (lunes a viernes, sin festivos) y falta tiempo para
    // la hora de corte; si no, se muestra el siguiente día laborable. Festivos y hora de corte: metafields de tienda.
    class DtShippingTime extends HTMLElement {
      connectedCallback() {
        this.textElement = this.querySelector('[data-dt-shipping-time-text]');
        var cutoff = /^(\d{1,2}):(\d{2})$/.exec((this.dataset.cutoff || '').trim());
        if (!this.textElement || !cutoff) return;

        this.cutoffMinutes = parseInt(cutoff[1], 10) * 60 + parseInt(cutoff[2], 10);
        this.holidays = (this.dataset.holidays || '').split(',').filter(Boolean);
        this.render();
        this.timer = window.setInterval(this.render.bind(this), 30000);
      }

      disconnectedCallback() {
        if (this.timer) window.clearInterval(this.timer);
      }

      // Fecha y hora actuales en Madrid; day es una fecha UTC a medianoche que representa el día civil de Madrid
      madridNow() {
        var parts = {};
        new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date()).forEach(function (part) { parts[part.type] = part.value; });

        return {
          day: new Date(Date.UTC(parseInt(parts.year, 10), parseInt(parts.month, 10) - 1, parseInt(parts.day, 10))),
          seconds: (parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10)) * 60 + parseInt(parts.second, 10)
        };
      }

      isWorkingDay(day) {
        var weekday = day.getUTCDay();
        return weekday !== 0 && weekday !== 6 && this.holidays.indexOf(day.toISOString().slice(0, 10)) === -1;
      }

      render() {
        var now = this.madridNow();
        var today = now.day;
        var open = this.isWorkingDay(today) && now.seconds < this.cutoffMinutes * 60;
        var text;

        if (open) {
          var minutes = Math.ceil((this.cutoffMinutes * 60 - now.seconds) / 60);
          var hours = Math.floor(minutes / 60);
          var time = hours > 0 ? hours + ' h ' + (minutes % 60) + ' min' : minutes + ' min';
          text = this.dataset.today.replace('[tiempo]', time);
        } else {
          var next = new Date(today.getTime());
          do { next.setUTCDate(next.getUTCDate() + 1); } while (!this.isWorkingDay(next));

          var isTomorrow = next.getTime() - today.getTime() === 24 * 60 * 60 * 1000;
          if (isTomorrow) {
            text = this.dataset.tomorrow;
          } else {
            var weekdayName = new Intl.DateTimeFormat(window.Shopify.locale, { weekday: 'long', timeZone: 'UTC' }).format(next);
            text = this.dataset.weekday.replace('[día]', weekdayName);
          }
        }

        this.textElement.innerHTML = text;
        this.classList.toggle('is-open', open);
        this.hidden = false;
      }
    }

    if (!window.customElements.get('dt-shipping-time')) {
      window.customElements.define('dt-shipping-time', DtShippingTime);
    }

    // DT Pop-up de marketing (TASK-0107): abre el <x-modal> de la sección tras el retardo, una vez por sesión.
    // Si el formulario se acaba de enviar (data-open-now) se abre sin retardo ni mirar la sesión, para mostrar el resultado.
    document.querySelectorAll('[data-dt-marketing-popup]').forEach(function (popup) {
      var storageKey = 'dt_marketing_popup_' + popup.dataset.sectionId;
      var openNow = popup.hasAttribute('data-open-now');
      var seen = false;
      try {
        seen = window.sessionStorage.getItem(storageKey) === '1';
      } catch (e) {}
      if (seen && !openNow) return;

      var open = function () {
        window.customElements.whenDefined('x-modal').then(function () {
          popup.show();
          try {
            window.sessionStorage.setItem(storageKey, '1');
          } catch (e) {}
        });
      };

      if (openNow) {
        open();
      } else {
        window.setTimeout(open, (parseInt(popup.dataset.delay, 10) || 0) * 1000);
      }
    });

    // Header: ocultar al hacer scroll en páginas de colección (solo escritorio — en móvil se queda sticky, TASK-0063)
    if (document.body.classList.contains('template-collection')) {
      var lastScrollY = window.scrollY;
      var header = document.querySelector('x-header');
      var isMobileHeaderQuery = window.matchMedia(window.themeVariables.mediaQueries['sm-max']);
      window.addEventListener('scroll', function () {
        if (!header || isMobileHeaderQuery.matches) return;
        if (window.scrollY > lastScrollY && window.scrollY > 80) {
          header.classList.add('dt-header--hidden');
          document.body.classList.add('dt-header-hidden');
        } else {
          header.classList.remove('dt-header--hidden');
          document.body.classList.remove('dt-header-hidden');
        }
        lastScrollY = window.scrollY;
      }, { passive: true });
    }

  });

})();